// src/pages/HomePage.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const quizzes = [
    { id: 1, state: 'CT', title: 'CT Permit Practice Test 1', description: '20 questions to help you prepare for the Connecticut DMV permit exam.' },
    { id: 2, state: 'CT', title: 'CT Permit Practice Test 2', description: 'Another set of 20 questions for the Connecticut DMV test.' },
    { id: 3, state: 'CT', title: 'CT Road Signs Quiz', description: 'Test your knowledge of Connecticut road signs.' },
    { id: 4, state: 'CT', title: 'CT Fines & Limits Quiz', description: 'Practice questions about fines and limits in Connecticut.' },
    { id: 5, state: 'NY', title: 'NY Permit Practice Test 1', description: '20 questions to help you prepare for the New York DMV permit exam.' },
    { id: 6, state: 'NY', title: 'NY Permit Practice Test 2', description: 'Another set of 20 questions for the New York DMV test.' },
    { id: 7, state: 'NY', title: 'NY Road Signs Quiz', description: 'Test your knowledge of New York road signs.' },
    { id: 8, state: 'NY', title: 'NY Fines & Limits Quiz', description: 'Practice questions about fines and limits in New York.' },
];

function slugify(text) {
  return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

function HomePage() {
    const { t } = useTranslation();
    return (
        <>
            <main className="container py-4" role="main">                <div className="text-center mb-5">
                    <h1 className="display-4 fw-bold">{t('home.title')}</h1>
                    <p className="lead" role="doc-subtitle">{t('home.subtitle')}</p>
                </div>
                <div className="row row-cols-1 row-cols-md-2 g-4" role="list" aria-label={t('home.availableQuizzes')}>
                    {quizzes.map(quiz => (
                        <div className="col" key={quiz.id} role="listitem">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body">
                                    <h2 className="h5 card-title" id={`quiz-${quiz.id}-title`}>{quiz.title}</h2>                                    <h3 className="h6 card-subtitle mb-2 text-muted" aria-label={`${t('home.state')}: ${t(`states.${quiz.state.toLowerCase()}`)}`}>
                                        {t('home.state')}: {t(`states.${quiz.state.toLowerCase()}`)}
                                    </h3>
                                    <p className="card-text" id={`quiz-${quiz.id}-desc`}>{quiz.description}</p>
                                    <a 
                                        href={`/quiz/${quiz.state.toLowerCase()}/${quiz.id}/${slugify(quiz.title)}`} 
                                        className="btn btn-primary"
                                        aria-labelledby={`quiz-${quiz.id}-title quiz-${quiz.id}-desc`}
                                        role="button"
                                    >
                                        {t('home.startQuiz')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </main>
        </>
    );
}

export default HomePage;
